// import React, { useState, useEffect } from "react";
// import { Box, Button, TextField, Grid, MenuItem } from "@mui/material";
// import Slider from "react-slick";
// import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
// import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
// import { useTheme } from "@mui/material/styles";
// import { Link } from "react-router-dom";
// import { Dialog, DialogContent, Typography } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";

// // Inline slick CSS
// const slickCSS = `
// .slick-slider {
//   position: relative;
//   display: block;
//   box-sizing: border-box;
//   -webkit-user-select: none;
//   -moz-user-select: none;
//   -ms-user-select: none;
//   user-select: none;
//   -webkit-touch-callout: none;
//   -khtml-user-select: none;
//   -ms-touch-action: pan-y;
//   touch-action: pan-y;
//   -webkit-tap-highlight-color: transparent;
// }

// .slick-list {
//   position: relative;
//   display: block;
//   overflow: hidden;
//   margin: 0;
//   padding: 0;
// }

// .slick-list:focus {
//   outline: none;
// }

// .slick-list.dragging {
//   cursor: pointer;
//   cursor: hand;
// }

// .slick-slider .slick-track,
// .slick-slider .slick-list {
//   -webkit-transform: translate3d(0, 0, 0);
//   -moz-transform: translate3d(0, 0, 0);
//   -ms-transform: translate3d(0, 0, 0);
//   -o-transform: translate3d(0, 0, 0);
//   transform: translate3d(0, 0, 0);
// }

// .slick-track {
//   position: relative;
//   top: 0;
//   left: 0;
//   display: block;
//   margin-left: auto;
//   margin-right: auto;
// }

// .slick-track:before,
// .slick-track:after {
//   display: table;
//   content: '';
// }

// .slick-track:after {
//   clear: both;
// }

// .slick-loading .slick-track {
//   visibility: hidden;
// }

// .slick-slide {
//   display: none;
//   float: left;
//   height: 100%;
//   min-height: 1px;
// }

// [dir='rtl'] .slick-slide {
//   float: right;
// }



// .slick-slide.slick-loading img {
//   display: none;
// }

// .slick-slide.dragging img {
//   pointer-events: none;
// }

// .slick-initialized .slick-slide {
//   display: block;
// }

// .slick-loading .slick-slide {
//   visibility: hidden;
// }

// .slick-vertical .slick-slide {
//   display: block;
//   height: auto;
//   border: 1px solid transparent;
// }

// .slick-arrow.slick-hidden {
//   display: none;
// }
// //   .slick-slide img {
// //   display: block;
// //   margin-top: 60px;
// // }

// @media (min-width: 768px) {
//   .slick-slide img {
//     margin-top: 80px;
//   }
// }

// @media (min-width: 1024px) {
//   .slick-slide img {
//     margin-top: 100px;
//   }
// }

// @media (min-width: 1440px) {
//   .slick-slide img {
//     margin-top: 130px;
//   }
// }

// @media (min-width: 2560px) {
//   .slick-slide img {
//     margin-top: 160px;
//   }
// }
// `;

// const backgroundImage =
//   "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/carmodels%2FScreenshot%202026-05-19%20at%2011.04.32%E2%80%AFPM.png?alt=media&token=aeb699f5-88f9-4c80-b8db-966268227f3b";
// const car1 =
//   "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/carmodels%2Fmgi-hector-model-car.png?alt=media&token=2a8c4677-56b2-46fd-963d-2041f6019fd0";
// const car2 =
//   "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/carmodels%2Fglostor-model-car.png?alt=media&token=4ea8a814-d952-4774-a3f0-dd9c993478d0";
// const car3 =
//   "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/carmodels%2Fcmmet-model-car.png?alt=media&token=75fc8f35-0982-464f-aba3-010403c1af39";
// const car4 =
//   "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/carmodels%2Fastor-model-car.png?alt=media&token=d5d9eda2-58ce-4bd1-9ba1-ece743960948";
// const car5 =
//   "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/carmodels%2Fzs-img-car.png?alt=media&token=34b67158-0218-43c0-ab78-a4eed6aba5f9";
// const car6 =
//   "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/carmodels%2Fcuv-img.png?alt=media&token=97665ca0-7a1a-442d-8ba4-18430afccdde";

// const ResponsiveCarousel = ({ autoSlide, autoSlideInterval, props }) => {
//   const theme = useTheme();
//   const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
//   const [isTablet, setIsTablet] = useState(
//     window.innerWidth >= 768 && window.innerWidth < 1024,
//   );
//   const [isDesktop1024, setIsDesktop1024] = useState(
//     window.innerWidth >= 1024 && window.innerWidth < 1440,
//   );
//   const [isLargeDesktop, setIsLargeDesktop] = useState(
//     window.innerWidth >= 1440 && window.innerWidth < 2560,
//   );
//   const [is4KDesktop, setIs4KDesktop] = useState(window.innerWidth >= 2560);

//   const [openTestDrive, setOpenTestDrive] = useState(false);
//   const [address, setAddress] = useState();
//   const [name, setName] = useState();
//   const [email, setEmail] = useState();
//   const [mobile, setMobile] = useState();
//   const [modelType, setModelType] = useState();
//   const [dateTime, setDateTime] = useState(null);
//   const [emailError, setEmailError] = useState();
//   const [mobileError, setMobileError] = useState();
//   const [currentSlide, setCurrentSlide] = useState(0);

//   const sliderRef = React.createRef();

//   const carData = [
//     {
//       id: 1,
//       image: car1,
//       smallhead: "DESIGNED TO SURPRISE",
//       headings: "MG HECTOR",
//       price: "₹11.99* LAKH",
//       features: "I-swipe touch gesture controls",
//       testDriveLink: "Hector",
//       modelType: "Hector",
//     },
//     {
//       id: 2,
//       image: car2,
//       smallhead: "DRIVE UNSTOPPABLE",
//       headings: "MG GLOSTER",
//       price: "₹38.33* LAKH",
//       features: "4x4, 7 Terrain",
//       testDriveLink: "Gloster",
//       modelType: "Gloster",
//     },
//     {
//       id: 3,
//       image: car3,
//       price: "₹4.99 LAKH* + 3.1/km*",
//       smallhead: "THE STREET SMART CAR",
//       headings: "MG COMET EV",
//       features: "Floating Twin Display",
//       testDriveLink: "Comet",
//       modelType: "Comet Ev",
//     },
//     {
//       id: 4,
//       image: car4,
//       price: "₹9.65* LAKH",
//       smallhead: "THE MOST ADVANCED SUV",
//       headings: "MG ASTOR",
//       features: "ADAS L2",
//       testDriveLink: "Astor",
//       modelType: "Astor",
//     },
//     {
//       id: 5,
//       image: car5,
//       price: "₹13 LAKH* + 4.5/km*",
//       smallhead: "EVING IS LIVING 2024",
//       headings: "MG ZS EV",
//       features: "50.3 kWh Battery",
//       testDriveLink: "ZsEv",
//       modelType: "Zs EV",
//     },
//     {
//       id: 6,
//       image: car6,
//       price: "₹9.99* Lakh + ₹3.9/km*",
//       smallhead: "LIVE BUSINESS CLASS 2024",
//       headings: "MG WINDSOR EV",
//       features: "Convenience",
//       testDriveLink: "Windsor",
//       modelType: "Windsor EV",
//     },
//   ];

//   const sliderSettings = {
//     dots: false,
//     arrows: false,
//     infinite: true,
//     // autoplay: autoSlide || true,
//     // autoplaySpeed: autoSlideInterval || 3000,
//     speed: 800,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     pauseOnHover: false,
//     swipeToSlide: true,
//     beforeChange: (current, next) => setCurrentSlide(next),
//   };

//   const handleTestDriveClick = (link) => {
//     window.open(link, "_blank");
//   };

//   useEffect(() => {
//     // Add slick CSS inline
//     const style = document.createElement("style");
//     style.innerHTML = slickCSS;
//     document.head.appendChild(style);

//     const handleResize = () => {
//       const w = window.innerWidth;
//       setIsMobile(w < 768);
//       setIsTablet(w >= 768 && w < 1024);
//       setIsDesktop1024(w >= 1024 && w < 1440);
//       setIsLargeDesktop(w >= 1440 && w < 2560);
//       setIs4KDesktop(w >= 2560);
//     };

//     window.addEventListener("resize", handleResize);

//     return () => {
//       window.removeEventListener("resize", handleResize);
//       // Clean up the style tag
//       const styleTag = document.querySelector("style[data-slick-inline]");
//       if (styleTag) {
//         styleTag.remove();
//       }
//     };
//   }, []);

//   const validateEmail = (email) => {
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     return emailRegex.test(email);
//   };

//   const validateMobile = (mobile) => {
//     const mobileRegex = /^\+?\d{10,14}$/;
//     return mobileRegex.test(mobile);
//   };

//   const handleSubmit = (event) => {
//     event.preventDefault();
//     let valid = true;

//     if (!validateEmail(email)) {
//       setEmailError("Please enter a valid email address");
//       valid = false;
//     } else {
//       setEmailError("");
//     }

//     if (!validateMobile(mobile)) {
//       setMobileError("Please enter a valid mobile number");
//       valid = false;
//     } else {
//       setMobileError("");
//     }

//     if (valid) {
//       props.BookTestDrive(name, email, mobile, modelType, dateTime, address);
//       setName("");
//       setEmail("");
//       setMobile("");
//       setModelType("");
//       setDateTime("");
//       setAddress("");
//     }
//   };

//   const handlePrev = () => {
//     if (sliderRef.current) {
//       sliderRef.current.slickPrev();
//     }
//   };

//   const handleNext = () => {
//     if (sliderRef.current) {
//       sliderRef.current.slickNext();
//     }
//   };

//   return (
//     <>
//       <Box
//         sx={{
//           width: "100vw",
//           height: is4KDesktop
//             ? "1000px"
//             : isLargeDesktop
//               ? "800px"
//               : isMobile
//                 ? "420px"
//                 : isTablet
//                   ? "600px"
//                   : isDesktop1024
//                     ? "520px"
//                     : "700px",
//           overflow: "hidden",
//           position: "relative",
//           margin: 0,
//           padding: 0,
//           backgroundImage: `url(${backgroundImage})`,
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//         }}
//       >
//         {/* Left Arrow Button */}
//         <Button
//           onClick={handlePrev}
//           sx={{
//             position: "absolute",
//             left: isMobile ? "10px" : is4KDesktop ? "100px" : "40px",
//             top: "50%",
//             transform: "translateY(-50%)",
//             zIndex: 10,
//             color: "#fff",
//             background: "transparent",
//             border: "none",
//             padding: "0",
//             minWidth: "auto",
//             "&:hover": {
//               backgroundColor: "rgba(255, 255, 255, 0.2)",
//               color: "#ffeb3b",
//             },
//           }}
//         >
//           <ArrowBackIosIcon
//             sx={{
//               fontSize: is4KDesktop ? 40 : isMobile ? 24 : 30,
//               color: "#fff",
//             }}
//           />
//         </Button>

//         {/* Right Arrow Button */}
//         <Button
//           onClick={handleNext}
//           sx={{
//             position: "absolute",
//             right: isMobile ? "10px" : is4KDesktop ? "100px" : "40px",
//             top: "50%",
//             transform: "translateY(-50%)",
//             zIndex: 10,
//             color: "#fff",
//             background: "transparent",
//             border: "none",
//             padding: "0",
//             minWidth: "auto",
//             "&:hover": {
//               backgroundColor: "rgba(255, 255, 255, 0.2)",
//               color: "#ffeb3b",
//             },
//           }}
//         >
//           <ArrowForwardIosIcon
//             sx={{
//               fontSize: is4KDesktop ? 40 : isMobile ? 24 : 30,
//               color: "#fff",
//             }}
//           />
//         </Button>

//         <Box
//           sx={{
//             width: "100%",
//             height: "100%",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//           }}
//         >
//           <Slider
//             ref={sliderRef}
//             {...sliderSettings}
//             style={{
//               width: "100%",
//               height: "100%",
//             }}
//           >
//             {carData.map((car, index) => (
//               // The per-slide Box — add overflow: hidden and fix height:
//               <Box
//                 key={car.id}
//                 sx={{
//                   display: "flex !important",
//                   flexDirection: "column",
//                   alignItems: "center",
//                   justifyContent: "center", // ← changed
//                   height: is4KDesktop
//                     ? "1000px"
//                     : isLargeDesktop
//                       ? "800px"
//                       : isMobile
//                         ? "420px"
//                         : isTablet
//                           ? "600px"
//                           : "520px",
//                   width: "100%",
//                   padding: is4KDesktop
//                     ? "40px"
//                     : isMobile
//                       ? "10px 20px"
//                       : "20px",
//                   position: "relative",
//                   overflow: "hidden", // ← ADD THIS
//                   paddingTop: isMobile ? "30px" : undefined,
//                 }}
//               >
//                 <Box
//                   sx={{
//                     display: "flex",
//                     flexDirection: "column",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     width: "100%",
//                     height: "100%",
//                   }}
//                 >
//                   <img
//                     src={car.image}
//                     alt={`Car ${car.id}`}
//                     style={{
//                       width: is4KDesktop
//                         ? "35%"
//                         : isMobile
//                           ? "100%"
//                           : isTablet
//                             ? "70%"
//                             : isDesktop1024
//                               ? "32%"
//                               : isLargeDesktop
//                                 ? "40%"
//                                 : "50%",
//                       height: "auto",
//                       objectFit: "contain", // ← change "cover" to "contain"
//                       borderRadius: "10px",
//                       maxHeight: is4KDesktop
//                         ? "500px"
//                         : isMobile
//                           ? "180px" // ← reduce from 200px
//                           : "350px",
//                       marginTop: "40px", // ← reduce mobile marginTop
//                     }}
//                   />
//                   <Box
//                     sx={{
//                       color: "white",
//                       padding: is4KDesktop ? "20px" : isMobile ? "5px" : "10px",
//                       borderRadius: "10px",
//                       textAlign: "center",
//                       width: is4KDesktop
//                         ? "40%"
//                         : isMobile
//                           ? "100%"
//                           : isTablet
//                             ? "60%"
//                             : isDesktop1024
//                               ? "40%"
//                               : isLargeDesktop
//                                 ? "30%"
//                                 : "60%",
//                       marginTop: is4KDesktop
//                         ? "20px"
//                         : isMobile
//                           ? "10px"
//                           : "15px",
//                       // backgroundColor: "rgba(0, 0, 0, 0.5)",
//                     }}
//                   >
//                     <p
//                       style={{
//                         fontSize: is4KDesktop ? "24px" : "14px",
//                         margin: 0,
//                         wordSpacing: "5px",
//                         fontWeight: is4KDesktop ? "500" : "normal",
//                       }}
//                     >
//                       {car.smallhead}
//                     </p>
//                     <h3
//                       style={{
//                         fontSize: is4KDesktop ? "36px" : "20px",
//                         margin: "10px 0",
//                         fontWeight: "700",
//                       }}
//                     >
//                       {car.headings}
//                     </h3>
//                     <Box
//                       sx={{
//                         display: "flex",
//                         justifyContent: "center",
//                         gap: is4KDesktop ? "60px" : { md: "30px", xs: "18px" },
//                       }}
//                     >
//                       <p>
//                         <span
//                           style={{
//                             fontSize: is4KDesktop ? "20px" : "12px",
//                             fontWeight: is4KDesktop ? "500" : "normal",
//                           }}
//                         >
//                           STARTING AT
//                         </span>
//                         <br />
//                         <b
//                           style={{
//                             fontSize: is4KDesktop
//                               ? "28px"
//                               : isMobile
//                                 ? "12px"
//                                 : "17px",
//                           }}
//                         >
//                           {car.price}
//                         </b>
//                       </p>
//                       <p>
//                         <span
//                           style={{
//                             fontSize: is4KDesktop ? "20px" : "12px",
//                             fontWeight: is4KDesktop ? "500" : "normal",
//                           }}
//                         >
//                           FEATURES
//                         </span>
//                         <br />
//                         <b
//                           style={{
//                             fontSize: is4KDesktop
//                               ? "28px"
//                               : isMobile
//                                 ? "12px"
//                                 : "17px",
//                           }}
//                         >
//                           {car.features}
//                         </b>
//                       </p>
//                     </Box>
//                     <Box
//   sx={{
//     display: "flex",
//     gap: "8px",
//     justifyContent: "center",
//     mt: isMobile ? "auto" : is4KDesktop ? "20px" : "10px",
//     width: "100%",
//     pb: isMobile ? "15px" : 0,
//   }}
// >
//                       <Link to={car.testDriveLink}>
//                         <Button
//                           variant="outlined"
//                           sx={{
//                             color: "#fff",
//                             borderColor: "#fff",
//                             fontSize: is4KDesktop ? "18px" : "14px",
//                             padding: is4KDesktop ? "12px 24px" : "6px 12px",
//                             minWidth: is4KDesktop ? "150px" : "auto",
//                           }}
//                         >
//                           EXPLORE
//                         </Button>
//                       </Link>

//                       <Button
//                         variant="contained"
//                         sx={{
//                           backgroundColor: "#794F36",
//                           color: "white",
//                           fontSize: is4KDesktop
//                             ? "18px"
//                             : isMobile
//                               ? "12px"
//                               : "15px",
//                           // padding: is4KDesktop ? "12px 24px" : "6px 12px",
//                           minWidth: is4KDesktop ? "150px" : "auto",
//                         }}
//                         onClick={() => {
//                           setModelType(car.modelType);
//                           setOpenTestDrive(true);
//                         }}
//                       >
//                         TEST DRIVE
//                       </Button>
//                     </Box>
//                   </Box>
//                 </Box>
//               </Box>
//             ))}
//           </Slider>
//         </Box>

//         {/* Custom Dots Indicator */}
//         <Box
//           sx={{
//             display: "flex",
//             justifyContent: "center",
//             position: "absolute",
//             bottom: is4KDesktop ? "40px" : "0px",
//             width: "100%",
//             gap: is4KDesktop ? "16px" : "8px",
//           }}
//         >
//           {carData.map((item, index) => (
//             <Box
//               key={index}
//               sx={{
//                 width: is4KDesktop ? "16px" : "10px",
//                 height: is4KDesktop ? "16px" : "10px",
//                 borderRadius: "50%",
//                 backgroundColor: index === currentSlide ? "red" : "#fff",
//                 opacity: index === currentSlide ? 1 : 0.5,
//                 cursor: "pointer",
//                 transition: "background-color 0.3s",
//                 "&:hover": {
//                   backgroundColor: index === currentSlide ? "red" : "#ccc",
//                 },
//               }}
//               onClick={() => {
//                 if (sliderRef.current) {
//                   sliderRef.current.slickGoTo(index);
//                 }
//               }}
//             />
//           ))}
//         </Box>
//       </Box>

//       {/* Test Drive Dialog */}
//       <Dialog
//         open={openTestDrive}
//         onClose={() => setOpenTestDrive(false)}
//         maxWidth="md"
//         fullWidth
//         BackdropProps={{
//           style: {
//             backgroundColor: "rgba(0, 0, 0, 0.3)",
//             backdropFilter: "blur(5px)",
//           },
//         }}
//         PaperProps={{
//           sx: {
//             maxWidth: is4KDesktop ? "1200px" : "md",
//             margin: is4KDesktop ? "40px" : "auto",
//           },
//         }}
//       >
//         <Box
//           sx={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             p: is4KDesktop ? 3 : 2,
//           }}
//         >
//           <Box sx={{ width: "100%" }}>
//             <Typography
//               sx={{
//                 color: "#D62E31",
//                 textAlign: "center",
//                 fontSize: is4KDesktop
//                   ? "48px"
//                   : { md: "40px", xs: "20px", sm: "35px" },
//                 fontFamily: "Gill Sans, Gill Sans MT, Calibri, sans-serif",
//                 fontWeight: "bolder",
//               }}
//             >
//               Book a Test Drive
//             </Typography>
//           </Box>
//           <Box>
//             <CloseIcon
//               onClick={() => setOpenTestDrive(false)}
//               sx={{
//                 fontSize: is4KDesktop ? 32 : 24,
//                 cursor: "pointer",
//                 "&:hover": { color: "#D62E31" },
//               }}
//             />
//           </Box>
//         </Box>
//         <DialogContent sx={{ p: is4KDesktop ? 4 : 3 }}>
//           <form onSubmit={handleSubmit}>
//             <Grid container spacing={is4KDesktop ? 4 : 2}>
//               <Grid item xs={12}>
//                 <Typography
//                   variant="body1"
//                   sx={{
//                     fontSize: is4KDesktop ? "18px" : "12px",
//                     textAlign: "center",
//                     fontWeight: "700",
//                     mb: is4KDesktop ? 3 : 1,
//                   }}
//                 >
//                   Please fill in the mandatory details for booking a Test Drive.
//                 </Typography>
//               </Grid>
//               <Grid container spacing={is4KDesktop ? 4 : 2}>
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     margin="dense"
//                     label="Name"
//                     name="name"
//                     fullWidth
//                     value={name}
//                     onChange={(e) => setName(e.target.value)}
//                     required
//                     InputLabelProps={{
//                       sx: {
//                         "& .MuiInputLabel-asterisk": { color: "red" },
//                         fontSize: is4KDesktop ? "18px" : "inherit",
//                       },
//                     }}
//                     inputProps={{
//                       style: { fontSize: is4KDesktop ? "18px" : "inherit" },
//                     }}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     margin="dense"
//                     label="Email"
//                     name="email"
//                     type="email"
//                     fullWidth
//                     value={email}
//                     onChange={(e) => setEmail(e.target.value)}
//                     required
//                     error={!!emailError}
//                     helperText={emailError}
//                     InputLabelProps={{
//                       sx: {
//                         "& .MuiInputLabel-asterisk": { color: "red" },
//                         fontSize: is4KDesktop ? "18px" : "inherit",
//                       },
//                     }}
//                     inputProps={{
//                       style: { fontSize: is4KDesktop ? "18px" : "inherit" },
//                     }}
//                   />
//                 </Grid>
//               </Grid>
//               <Grid container spacing={is4KDesktop ? 4 : 2}>
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     margin="dense"
//                     label="Mobile"
//                     name="Mobile"
//                     type="number"
//                     fullWidth
//                     value={mobile}
//                     onChange={(e) => setMobile(e.target.value)}
//                     required
//                     error={!!mobileError}
//                     helperText={mobileError}
//                     InputLabelProps={{
//                       sx: {
//                         "& .MuiInputLabel-asterisk": { color: "red" },
//                         fontSize: is4KDesktop ? "18px" : "inherit",
//                       },
//                     }}
//                     inputProps={{
//                       style: { fontSize: is4KDesktop ? "18px" : "inherit" },
//                     }}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     margin="dense"
//                     label="Model Type"
//                     name="Model Type"
//                     type="text"
//                     fullWidth
//                     value={modelType}
//                     InputLabelProps={{
//                       sx: {
//                         "& .MuiInputLabel-asterisk": { color: "red" },
//                         fontSize: is4KDesktop ? "18px" : "inherit",
//                       },
//                     }}
//                     inputProps={{
//                       style: { fontSize: is4KDesktop ? "18px" : "inherit" },
//                     }}
//                   />
//                 </Grid>
//               </Grid>
//               <Grid container spacing={is4KDesktop ? 4 : 2}>
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     margin="dense"
//                     label="Test Drive Date & Time"
//                     name="date"
//                     type="datetime-local"
//                     fullWidth
//                     value={dateTime}
//                     onChange={(e) => setDateTime(e.target.value)}
//                     InputLabelProps={{
//                       shrink: true,
//                       sx: {
//                         "& .MuiInputLabel-asterisk": { color: "red" },
//                         fontSize: is4KDesktop ? "18px" : "inherit",
//                       },
//                     }}
//                     inputProps={{
//                       style: { fontSize: is4KDesktop ? "18px" : "inherit" },
//                     }}
//                     required
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     margin="dense"
//                     label="Address"
//                     name="address"
//                     type="text"
//                     fullWidth
//                     value={address}
//                     onChange={(e) => setAddress(e.target.value)}
//                     InputLabelProps={{
//                       shrink: true,
//                       sx: {
//                         "& .MuiInputLabel-asterisk": { color: "red" },
//                         fontSize: is4KDesktop ? "18px" : "inherit",
//                       },
//                     }}
//                     inputProps={{
//                       style: { fontSize: is4KDesktop ? "18px" : "inherit" },
//                     }}
//                     required
//                   />
//                 </Grid>
//               </Grid>
//               <Grid item xs={12}>
//                 <Box
//                   sx={{
//                     display: "flex",
//                     justifyContent: "center",
//                     alignItems: "center",
//                     width: "100%",
//                     mt: is4KDesktop ? 4 : 2,
//                   }}
//                 >
//                   <Button
//                     type="submit"
//                     variant="contained"
//                     color="primary"
//                     sx={{
//                       backgroundColor: "#D23132",
//                       fontWeight: "bolder",
//                       fontSize: is4KDesktop ? "20px" : "16px",
//                       padding: is4KDesktop ? "16px 48px" : "8px 24px",
//                       minWidth: is4KDesktop ? "200px" : "auto",
//                     }}
//                   >
//                     Submit
//                   </Button>
//                 </Box>
//               </Grid>
//             </Grid>
//           </form>
//         </DialogContent>
//       </Dialog>
//     </>
//   );
// };

// export default ResponsiveCarousel;











































import React, { useState, useEffect, useRef } from "react";
import { Box, Button, TextField, Grid } from "@mui/material";
import Slider from "react-slick";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Link } from "react-router-dom";
import { Dialog, DialogContent, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const slickCSS = `
.slick-slider {
  position: relative;
  display: block;
  box-sizing: border-box;
  -webkit-user-select: none;
  user-select: none;
  touch-action: pan-y;
  -webkit-tap-highlight-color: transparent;
}
.slick-list {
  position: relative;
  display: block;
  overflow: hidden;
  margin: 0;
  padding: 0;
}
.slick-list:focus { outline: none; }
.slick-slider .slick-track,
.slick-slider .slick-list {
  transform: translate3d(0, 0, 0);
}
.slick-track {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.slick-track:before,
.slick-track:after { display: table; content: ''; }
.slick-track:after { clear: both; }
.slick-loading .slick-track { visibility: hidden; }
.slick-slide {
  display: none;
  float: left;
  height: 100%;
  min-height: 1px;
  transition: transform 0.4s ease, opacity 0.4s ease;
}
.slick-initialized .slick-slide { display: block; }
.slick-loading .slick-slide { visibility: hidden; }
.slick-arrow.slick-hidden { display: none; }

/* Side slides: scaled down by default */
.slick-slide img {
  transform: scale(0.88);
  opacity: 0.95;
  transition: transform 0.4s ease, opacity 0.4s ease;
}

/* Center/active slide: full scale */
.slick-current img {
  transform: scale(1) !important;
  opacity: 1 !important;
}
`;

const backgroundImage =
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/carmodels%2FScreenshot%202026-05-19%20at%2011.04.32%E2%80%AFPM.png?alt=media&token=aeb699f5-88f9-4c80-b8db-966268227f3b";

const car1 =
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/carmodels%2Fmgi-hector-model-car.png?alt=media&token=2a8c4677-56b2-46fd-963d-2041f6019fd0";
const car2 =
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/carmodels%2Fglostor-model-car.png?alt=media&token=4ea8a814-d952-4774-a3f0-dd9c993478d0";
const car3 =
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/carmodels%2Fcmmet-model-car.png?alt=media&token=75fc8f35-0982-464f-aba3-010403c1af39";
const car4 =
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/carmodels%2Fastor-model-car.png?alt=media&token=d5d9eda2-58ce-4bd1-9ba1-ece743960948";
const car5 =
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/carmodels%2Fzs-img-car.png?alt=media&token=34b67158-0218-43c0-ab78-a4eed6aba5f9";
const car6 =
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/carmodels%2Fcuv-img.png?alt=media&token=97665ca0-7a1a-442d-8ba4-18430afccdde";
const car7 = "https://www.mgmotor.co.in/content/dam/mgmotor/images/mj-img-dsc-001.png";
const car8 =
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/carmodels%2F004-khaki-green-s-black-image-2.webp?alt=media&token=11aa4633-35ab-41ee-8fee-23a13585ea28";
const car9 =
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/carmodels%2F007-hw-phev-turquoise-green-pearl-white-roof-2.webp?alt=media&token=b4742447-61e1-4764-88c5-2cd2d71383a3";

const carData = [
  {
    id: 1,
    image: car1,
    smallhead: "DESIGNED TO SURPRISE",
    headings: "MG HECTOR",
    price: "₹11.99* LAKH",
    features: "I-swipe touch gesture controls",
    testDriveLink: "Hector",
    modelType: "Hector",
  },
  {
    id: 8,
    image: car8,
    smallhead: "DRIVE THE FUTURE",
    headings: "HECTOR TOMAHAWK EV",
    price: "₹13.99 LAKH* + 4.90/km*",
    features: "",
    testDriveLink: "HectorTomahawkEv",
    modelType: "Hector Tomahawk EV",
  },
  {
    id: 9,
    image: car9,
    smallhead: "DRIVE THE FUTURE",
    headings: "HECTOR TOMAHAWK PHEV",
    price: "₹21.79 LAKH* + 3.20/km*",
    features: "",
    testDriveLink: "HectorTomahawkPhev",
    modelType: "Hector Tomahawk PHEV",
  },
  {
    id: 2,
    image: car2,
    smallhead: "DRIVE UNSTOPPABLE",
    headings: "MG GLOSTER",
    price: "₹38.33* LAKH",
    features: "4x4, 7 Terrain",
    testDriveLink: "Gloster",
    modelType: "Gloster",
  },
  {
    id: 3,
    image: car3,
    smallhead: "THE STREET SMART CAR",
    headings: "MG COMET EV",
    price: "₹4.99 LAKH* + 3.1/km*",
    features: "Floating Twin Display",
    testDriveLink: "Comet",
    modelType: "Comet Ev",
  },
  {
    id: 4,
    image: car4,
    smallhead: "THE MOST ADVANCED SUV",
    headings: "MG ASTOR",
    price: "₹9.65* LAKH",
    features: "ADAS L2",
    testDriveLink: "Astor",
    modelType: "Astor",
  },
  {
    id: 5,
    image: car5,
    smallhead: "EVING IS LIVING 2024",
    headings: "MG ZS EV",
    price: "₹13 LAKH* + 4.5/km*",
    features: "50.3 kWh Battery",
    testDriveLink: "ZsEv",
    modelType: "Zs EV",
  },
  {
    id: 6,
    image: car6,
    smallhead: "LIVE BUSINESS CLASS 2024",
    headings: "MG WINDSOR EV",
    price: "₹9.99* Lakh + Rs.3.9/km*",
    features: "Convenience",
    testDriveLink: "Windsor",
    modelType: "Windsor EV",
  },
  {
    id: 7,
    image: car7,
    smallhead: "PREPARE FOR DOMINANCE",
    headings: "MG Majestor",
    price: "",
    features: "",
    testDriveLink: "majestor",
    modelType: "majestor",
  },
];

const ResponsiveCarousel = ({ autoSlide, autoSlideInterval, BookTestDrive }) => {
  const sliderRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(0);

  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1024
  );

  const [openTestDrive, setOpenTestDrive] = useState(false);
  const [address, setAddress]   = useState("");
  const [name, setName]         = useState("");
  const [email, setEmail]       = useState("");
  const [mobile, setMobile]     = useState("");
  const [modelType, setModelType] = useState("");
  const [dateTime, setDateTime] = useState("");
  const [emailError, setEmailError]   = useState("");
  const [mobileError, setMobileError] = useState("");

  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = slickCSS;
    document.head.appendChild(style);

    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => {
      style.remove();
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const getCenterPadding = () => {
  if (windowWidth >= 1440) return "28%";
if (windowWidth >= 1024) return "24%";
if (windowWidth >= 768) return "18%";
if (windowWidth >= 480) return "10%";
return "5%";
  };

  // Height of the background section ONLY (without car overflow)
  const getBgHeight = () => {
    if (windowWidth >= 2560) return "520px";
    if (windowWidth >= 1440) return "380px";
    if (windowWidth >= 1024) return "310px";
    if (windowWidth >= 768)  return "250px";
    if (windowWidth >= 480)  return "185px";
    return "150px";
  };

  // How much the car image dips below bg into the white section
  const getCarOverflow = () => {
    if (windowWidth >= 1440) return "130px";
    if (windowWidth >= 1024) return "110px";
    if (windowWidth >= 768)  return "85px";
    if (windowWidth >= 480)  return "65px";
    return "50px";
  };

  const sliderSettings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: getCenterPadding(),
    swipeToSlide: true,
    pauseOnHover: false,
    beforeChange: (current, next) => setCurrentSlide(next),
  };

  const handlePrev = () => sliderRef.current?.slickPrev();
  const handleNext = () => sliderRef.current?.slickNext();

  const validateEmail  = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  const validateMobile = (v) => /^\+?\d{10,14}$/.test(v);

  const handleSubmit = (event) => {
    event.preventDefault();
    let valid = true;
    if (!validateEmail(email)) {
      setEmailError("Please enter a valid email address");
      valid = false;
    } else setEmailError("");
    if (!validateMobile(mobile)) {
      setMobileError("Please enter a valid mobile number");
      valid = false;
    } else setMobileError("");
    if (valid) {
      BookTestDrive?.(name, email, mobile, modelType, dateTime, address);
      setName(""); setEmail(""); setMobile(""); setModelType(""); setDateTime(""); setAddress("");
      setOpenTestDrive(false);
    }
  };

  const bgHeight    = getBgHeight();
  const carOverflow = getCarOverflow();
  // Car slider total height spans bg + the overflow into white section
  const carTotalHeight = `calc(${bgHeight} + ${carOverflow})`;

  return (
    <>
      {/* ══════════════════════════════════════════
          MAIN BANNER WRAPPER
          position: relative — car slider floats over bg + white strip
      ══════════════════════════════════════════ */}
      <Box sx={{ width: "100%", position: "relative", backgroundColor: "#fff" }}>

        {/* ── BACKGROUND IMAGE SECTION ── */}
        <Box
          sx={{
            width: "100%",
            height: bgHeight,
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            position: "relative",
          }}
        >
          {/* Left Arrow */}
          <Button
            onClick={handlePrev}
            sx={{
              position: "absolute",
              left: { xs: "6px", sm: "12px", md: "20px" },
              top: "120%",
              transform: "translateY(-50%)",
              zIndex: 20,
              minWidth: "auto",
              width: { xs: 30, sm: 36, md: 34 },
              height: { xs: 30, sm: 36, md: 34 },
              borderRadius: "6px",
              backgroundColor: "#D62E31",
              color: "#fff",
              p: 0,
              "&:hover": { backgroundColor: "#a01f20" },
            }}
          >
            <ArrowBackIosIcon sx={{ fontSize: { xs: 13, sm: 16, md: 18 }, ml: "3px" }} />
          </Button>

          {/* Right Arrow */}
          <Button
            onClick={handleNext}
            sx={{
              position: "absolute",
              right: { xs: "6px", sm: "12px", md: "20px" },
              top: "120%",
              transform: "translateY(-50%)",
              zIndex: 20,
              minWidth: "auto",
              width: { xs: 30, sm: 36, md: 34 },
              height: { xs: 30, sm: 36, md: 34 },
              borderRadius: "6px",
              backgroundColor: "#D62E31",
              color: "#fff",
              p: 0,
              "&:hover": { backgroundColor: "#a01f20" },
            }}
          >
            <ArrowForwardIosIcon sx={{ fontSize: { xs: 13, sm: 16, md: 18 } }} />
          </Button>
        </Box>

        {/* ── CAR IMAGE SLIDER ──
            Absolutely positioned from top of the component.
            Height = bgHeight + carOverflow so the bottom of the car
            dips into the white section below the bg image.
            zIndex 10 = above bg and white strip.
            pointerEvents none = clicks pass through to arrows/buttons.
        ── */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: carTotalHeight,
            zIndex: 10,
            pointerEvents: "none",
          }}
        >
          <Slider ref={sliderRef} {...sliderSettings}>
            {carData.map((car) => (
              <Box
                key={car.id}
                sx={{
                  height: carTotalHeight,
                  display: "flex !important",
                  alignItems: "flex-end",
                  justifyContent: "center",
                  outline: "none",
                  px: { xs: "4px", sm: "6px", md: "8px" },
                }}
              >
                <img
                  src={car.image}
                  alt={car.headings}
                  style={{
                    width: "80%",
                    height: "80%",
                    objectFit: "contain",
                    objectPosition: "center bottom",
                    display: "block",
                    userSelect: "none",
                    pointerEvents: "none",
                    filter: "drop-shadow(0px 8px 20px rgba(0,0,0,0.15))",
                  }}
                />
              </Box>
            ))}
          </Slider>
        </Box>

        {/* ── WHITE TEXT STRIP ──
            paddingTop accounts for car overflow so text appears
            just below where the car image ends.
        ── */}
        <Box
          sx={{
            backgroundColor: "#fff",
            width: "100%",
            textAlign: "center",
            pt: `calc(${carOverflow} + 12px)`,
            pb: { xs: 0.75, sm: 1.25 },
            px: { xs: 2, sm: 4, md: 8 },
          }}
        >
          {/* Subheading */}
          <Typography
            sx={{
              fontSize: { xs: "9px", sm: "10px", md: "11px" },
              letterSpacing: { xs: "1.5px", md: "2.5px" },
              color: "#888",
              fontWeight: 400,
              mb: { xs: "2px", md: "4px" },
              textTransform: "uppercase",
            }}
          >
            {carData[currentSlide]?.smallhead}
          </Typography>

          {/* Car Name */}
          <Typography
            sx={{
              fontSize: { xs: "17px", sm: "22px", md: "28px", lg: "32px" },
              fontWeight: 700,
              color: "#111",
              letterSpacing: "0.5px",
              mb: { xs: 0.75, md: 1.25 },
              lineHeight: 1.15,
              transition: "all 0.3s ease",
            }}
          >
            {carData[currentSlide]?.headings}
          </Typography>

          {/* Price + Features */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
              gap: { xs: "20px", sm: "36px", md: "56px" },
              mb: { xs: 1.25, md: 1.75 },
            }}
          >
            <Box sx={{ textAlign: "left" }}>
              <Typography
                sx={{
                  fontSize: { xs: "8px", sm: "10px", md: "11px" },
                  color: "#aaa",
                  letterSpacing: "1.5px",
                  textTransform: "uppercase",
                  mb: "2px",
                }}
              >
                STARTS AT
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "12px", sm: "15px", md: "18px" },
                  fontWeight: 700,
                  color: "#111",
                }}
              >
                {carData[currentSlide]?.price}
              </Typography>
            </Box>

            {/* vertical divider */}
            <Box
              sx={{
                width: "1px",
                backgroundColor: "#ddd",
                alignSelf: "stretch",
                my: "2px",
              }}
            />

            <Box sx={{ textAlign: "left" }}>
              <Typography
                sx={{
                  fontSize: { xs: "8px", sm: "10px", md: "11px" },
                  color: "#aaa",
                  letterSpacing: "1.5px",
                  textTransform: "uppercase",
                  mb: "2px",
                }}
              >
                FEATURES
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "12px", sm: "15px", md: "18px" },
                  fontWeight: 700,
                  color: "#111",
                }}
              >
                {carData[currentSlide]?.features}
              </Typography>
            </Box>
          </Box>

          {/* CTA Buttons — workflow completely unchanged */}
          <Box
            sx={{
              display: "flex",
              gap: { xs: "8px", sm: "12px" },
              justifyContent: "center",
              mb: { xs: 0.5, md: 1 },
            }}
          >
            <Link
              to={carData[currentSlide]?.testDriveLink}
              style={{ textDecoration: "none" }}
            >
              <Button
                variant="outlined"
                sx={{
                  color: "#111",
                  borderColor: "#111",
                  fontSize: { xs: "10px", sm: "12px", md: "13px" },
                  px: { xs: 1.5, sm: 2.5, md: 3 },
                  py: { xs: 0.5, sm: 0.75, md: 1 },
                  fontWeight: 600,
                  letterSpacing: "1px",
                  borderRadius: "2px",
                  "&:hover": {
                    borderColor: "#D62E31",
                    color: "#D62E31",
                    backgroundColor: "transparent",
                  },
                }}
              >
                EXPLORE
              </Button>
            </Link>

            <Button
              variant="contained"
              sx={{
                backgroundColor: "#794F36",
                color: "#fff",
                fontSize: { xs: "10px", sm: "12px", md: "13px" },
                px: { xs: 1.5, sm: 2.5, md: 3 },
                py: { xs: 0.5, sm: 0.75, md: 1 },
                fontWeight: 600,
                letterSpacing: "1px",
                borderRadius: "2px",
                boxShadow: "none",
                "&:hover": { backgroundColor: "#5c3a26", boxShadow: "none" },
              }}
              onClick={() => {
                setModelType(carData[currentSlide]?.modelType);
                setOpenTestDrive(true);
              }}
            >
              TEST DRIVE
            </Button>
          </Box>
        </Box>

        {/* ── Dot Indicators ── */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: "8px",
            py: { xs: 0.75, md: 1 },
            backgroundColor: "#fff",
          }}
        >
          {carData.map((_, index) => (
            <Box
              key={index}
              onClick={() => sliderRef.current?.slickGoTo(index)}
              sx={{
                width: { xs: "8px", md: "10px" },
                height: { xs: "8px", md: "10px" },
                borderRadius: "50%",
                backgroundColor: index === currentSlide ? "#D62E31" : "#ccc",
                opacity: index === currentSlide ? 1 : 0.55,
                cursor: "pointer",
                transition: "background-color 0.3s",
                "&:hover": {
                  backgroundColor: index === currentSlide ? "#D62E31" : "#aaa",
                },
              }}
            />
          ))}
        </Box>
      </Box>

      {/* ══════════════════════════════════════════
          TEST DRIVE DIALOG — workflow unchanged
      ══════════════════════════════════════════ */}
      <Dialog
        open={openTestDrive}
        onClose={() => setOpenTestDrive(false)}
        maxWidth="md"
        fullWidth
        BackdropProps={{
          style: {
            backgroundColor: "rgba(0,0,0,0.3)",
            backdropFilter: "blur(5px)",
          },
        }}
        PaperProps={{
          sx: { borderRadius: "4px" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            p: { xs: 1.5, md: 2 },
          }}
        >
          <Box sx={{ width: "100%" }}>
            <Typography
              sx={{
                color: "#D62E31",
                textAlign: "center",
                fontSize: { md: "40px", sm: "30px", xs: "22px" },
                fontFamily: "Gill Sans, Gill Sans MT, Calibri, sans-serif",
                fontWeight: "bolder",
              }}
            >
              Book a Test Drive
            </Typography>
          </Box>
          <Box>
            <CloseIcon
              onClick={() => setOpenTestDrive(false)}
              sx={{
                fontSize: { xs: 20, md: 24 },
                cursor: "pointer",
                "&:hover": { color: "#D62E31" },
              }}
            />
          </Box>
        </Box>

        <DialogContent sx={{ p: { xs: 2, md: 3 } }}>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { xs: "11px", md: "12px" },
                    textAlign: "center",
                    fontWeight: "700",
                    mb: 1,
                  }}
                >
                  Please fill in the mandatory details for booking a Test Drive.
                </Typography>
              </Grid>

              <Grid container spacing={2} sx={{ px: 1 }}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    margin="dense"
                    label="Name"
                    name="name"
                    fullWidth
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                    InputLabelProps={{
                      sx: { "& .MuiInputLabel-asterisk": { color: "red" } },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    margin="dense"
                    label="Email"
                    name="email"
                    type="email"
                    fullWidth
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    error={!!emailError}
                    helperText={emailError}
                    InputLabelProps={{
                      sx: { "& .MuiInputLabel-asterisk": { color: "red" } },
                    }}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ px: 1 }}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    margin="dense"
                    label="Mobile"
                    name="Mobile"
                    type="number"
                    fullWidth
                    value={mobile}
                    onChange={(e) => setMobile(e.target.value)}
                    required
                    error={!!mobileError}
                    helperText={mobileError}
                    InputLabelProps={{
                      sx: { "& .MuiInputLabel-asterisk": { color: "red" } },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    margin="dense"
                    label="Model Type"
                    name="Model Type"
                    type="text"
                    fullWidth
                    value={modelType}
                    InputLabelProps={{
                      sx: { "& .MuiInputLabel-asterisk": { color: "red" } },
                    }}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ px: 1 }}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    margin="dense"
                    label="Test Drive Date & Time"
                    name="date"
                    type="datetime-local"
                    fullWidth
                    value={dateTime}
                    onChange={(e) => setDateTime(e.target.value)}
                    InputLabelProps={{
                      shrink: true,
                      sx: { "& .MuiInputLabel-asterisk": { color: "red" } },
                    }}
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    margin="dense"
                    label="Address"
                    name="address"
                    type="text"
                    fullWidth
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    InputLabelProps={{
                      shrink: true,
                      sx: { "& .MuiInputLabel-asterisk": { color: "red" } },
                    }}
                    required
                  />
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    mt: 2,
                  }}
                >
                  <Button
                    type="submit"
                    variant="contained"
                    sx={{
                      backgroundColor: "#D23132",
                      fontWeight: "bolder",
                      fontSize: { xs: "14px", md: "16px" },
                      padding: { xs: "6px 20px", md: "8px 24px" },
                      "&:hover": { backgroundColor: "#a01f20" },
                    }}
                  >
                    Submit
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ResponsiveCarousel;